import script from "./codeLogin.vue?vue&type=script&lang=ts&setup=true"
export * from "./codeLogin.vue?vue&type=script&lang=ts&setup=true"

import "./codeLogin.vue?vue&type=style&index=0&id=fca1d2ee&lang=scss&scoped=true"

import exportComponent from "E:\\gitProject\\营城\\yingcheng\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fca1d2ee"]])

export default __exports__